import SmallLoader from 'src/widgets/loaders/SmallLoader';
import { useAppSelector } from 'src/stateManagement/hooks/redux';
import css from './RepairPlanRankingLegend.module.scss';


export default function RepairPlanRankingLegend() {
    const t = useAppSelector(s => s.maps.repairPlan.rankingThresholds);
    const loading = useAppSelector(s => s.maps.repairPlan.rankingLoading);

    if (loading) {
        return (
            <div className={css.root}>
                <h6 className={css.title}>Балльная оценка</h6>
                <hr className={css.breakLine} />
                <SmallLoader text="Загрузка…" iconColor="#6b7280" />
            </div>
        );
    }

    if (!t) {
        return (
            <div className={css.root}>
                <h6 className={css.title}>Балльная оценка</h6>
                <hr className={css.breakLine} />
                <div className={css.empty}>Недостаточно данных</div>
            </div>
        );
    }

    const L = t.low.toLocaleString('ru-RU', { maximumFractionDigits: 0 });
    const H = t.high.toLocaleString('ru-RU', { maximumFractionDigits: 0 });

    return (
        <div className={css.root}>
            <h6 className={css.title}>Балльная оценка</h6>
            <hr className={css.breakLine} />
            <div className={css.itemsList}>
                <div className={css.item}><span className={`${css.swatch} ${css.low}`} />{`<\u00A0${L}`}</div>
                <div className={css.item}><span className={`${css.swatch} ${css.mid}`} />{`${L}\u00A0–\u00A0${H}`}</div>
                <div className={css.item}><span className={`${css.swatch} ${css.high}`} />{`\u2265\u00A0${H}`}</div>
            </div>
        </div>
    );
}